<script setup>
import { useBranchesStore } from "@/stores/branches.js";
import { ref, defineProps, computed } from "vue";
import { storeToRefs } from "pinia";

const branchStore = useBranchesStore();
const { selectedBranchData, branches } = storeToRefs(branchStore);
const isOpen = ref(false);

// eslint-disable-next-line no-undef
const emit = defineEmits(["changedBranch"]);

defineProps({
  showDetail: {
    type: Boolean,
    default: false,
  },
  inHp: {
    type: Boolean,
    default: false,
  },
});

const toggleDropdown = () => (isOpen.value = !isOpen.value);
const closeDropdown = () => (isOpen.value = false);

const changeBranch = (branch) => {
  if (selectedBranchData.value?.id === branch.id) {
    closeDropdown();
    return;
  }

  branchStore.setSelectedBranch(branch.id);
  emit("changedBranch", branch.id);
  toggleDropdown();
};

const fullAddressBranch = computed(
  () =>
    `${selectedBranchData.value?.street}, ${selectedBranchData.value?.zip} ${selectedBranchData.value?.city},${selectedBranchData.value?.country}`,
);
</script>

<template>
  <div
    class="branch-select"
    :class="{ 'hp-select': inHp }"
    v-click-outside="closeDropdown"
  >
    <button @click="toggleDropdown" class="branch-toggle">
      {{ $t("branches.select_branch") }}
    </button>

    <ul v-if="isOpen" class="branch-menu">
      <li
        v-for="(branch, index) in branches"
        :key="index"
        class="dropdown-item"
        @click="changeBranch(branch)"
      >
        <img :src="branch?.image_url" :alt="branch.name" class="branch-image" />
        <span class="branch-name">{{ branch.title }}</span>
      </li>
    </ul>
  </div>

  <div class="branch-data" v-if="showDetail && selectedBranchData?.title">
    <h3>
      <img
        :src="selectedBranchData?.image_url"
        :alt="selectedBranchData?.title"
      /><span>{{ selectedBranchData?.title }}</span>
    </h3>
    <p>{{ fullAddressBranch }}</p>
  </div>
</template>

<style scoped lang="scss">
.branch-select {
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
  &.hp-select {
    margin-top: 1em;
    .branch-toggle {
      font-size: 1.2em;
    }
  }
  .branch-toggle {
    background: none;
    border: none;
    color: #b99b00;
    font-size: 16px;
    cursor: pointer;
    font-weight: bold;
    padding: 0px;
  }

  .branch-menu {
    position: absolute;
    background: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 10px 0;
    width: 400px;
    max-width: calc(100vw - 30px);
    z-index: 10;
    li {
      display: flex;
      align-items: center;
      padding: 10px;
      cursor: pointer;
      transition: background 0.3s;
      &:hover {
        background: #f8f8f8;
      }
    }
  }

  .branch-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .calendar-btn {
    margin-left: auto;
    background: none;
    border: 1px solid #b99b00;
    color: #b99b00;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .calendar-btn:hover {
    background: #b99b00;
    color: white;
  }
}
.branch-data {
  display: flex;
  flex-wrap: wrap;
  h3 {
    display: flex;
    width: 100%;
    margin-bottom: 0;
    font-size: clamp(22px, 5vw, 38px);
    img {
      width: 20%;
      max-width: 50px;
      border-radius: 0.5rem;
      max-height: 50px;
      height: 100%;
    }
    span {
      display: inline-flex;
      height: 100%;
      padding-left: 10px;
      align-items: center;
      overflow-wrap: break-word;
      min-width: 0;
    }
  }
  p {
    font-weight: bold;
    margin-bottom: 0px;
  }
}
</style>
